import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class IntegrationResources extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/integrations' as const;

  pk() {
    return 'integrations';
  }
}
